import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { ActivityName } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import QuestionnaireFlow from '../components/activity/flow/QuestionnaireFlow';

const QuestionnaireFlowScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityName: ActivityName, activityId: string, initialStep: number, forceReset?: boolean }>, 'ActivitySubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const activityName = route.params?.activityName;
    const activityId = route.params?.activityId;
    const forceReset = route.params?.forceReset || false;
    
    const initialStep = forceReset ? 0 : (route.params?.initialStep || 0);

    const handleGoToHome = () => {
        navigation.navigate("Homepage");
    }
    
    return (
        <MainLayout navigation={handleGoToHome}>
            <QuestionnaireFlow activityName={activityName} activityId={activityId} initialStep={initialStep} forceReset={forceReset} />
        </MainLayout>
    );
};

export default QuestionnaireFlowScreen;